import { Button, InputNumber, Modal, Select } from "antd";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import Container from "../General/Container/Container";
import { useRef } from "react";
import PrintPage, { pageSizes, pageSizesObj } from "./PrintPage";

const PrintModal = ({
    visible,
    onClose = () => { },
    onSave = () => { },
    pages = [],
    filename = "sample-document"
}) => {
    const pageRef = useRef();
    const pageRef1 = useRef();

    const [currentPage, setCurrentPage] = useState('a4bondpaper');
    const [sideMargin, setSideMargin] = useState(5)
    const [topMargin, setTopMargin] = useState(10)

    const onChangeSize = (e) => {
        setCurrentPage(e)
    }
    const currentSize = pageSizesObj[currentPage]

    const onClickPrint = async () => {
        const pages = Array.from(pageRef.current.querySelectorAll(".print-actualpage"))
        if (pages.length) {
            const pageWidth = currentSize[0];
            const newWidth = pageWidth - (sideMargin * 2)
            let pdf = new jsPDF({
                unit: "mm", orientation: "p", format: currentSize
            });
            const getPages = (idx) => {
                const currentPage = pages[idx];
                if (!currentPage) {
                    onSave()
                    pdf.save(filename + '.pdf');
                    return
                }
                pdf.html(currentPage, {
                    callback: function (doc) {
                        getPages(idx + 1)
                    },
                    x: sideMargin,
                    y: idx ? currentSize[1] + (idx * topMargin) : topMargin,
                    width: newWidth, //target width in the PDF document
                    windowWidth: 794 //window width in CSS pixels
                });
            }
            getPages(0)
        }
    }
    const onClickCancel = () => {
        onClose(false);
    };
    return <Modal
        className="printmodal"
        open={visible}
        closable={false}
        maskClosable={false}
        title={null}
        footer={null}
    >
        <Container className="printmodal-cont drow">
            <Container className="printmodal-preview dcol align-center gap-3" ref={pageRef}>
                {pages.map((page) => {
                    return <PrintPage
                        sideMargin={sideMargin}
                        topMargin={topMargin}
                        pageSize={currentPage}
                    >
                        {page}
                    </PrintPage>
                })}
            </Container>
            <Container ref={pageRef1} className="printmodal-properties dcol justify-between">
                <Container className="printmodal-settings dcol fullw gap-1">
                    <span className="printmodal-settings-title">Settings:</span>
                    <Container className="drow fullw gap-1 align-center">
                        <span className="flex-1">Page size: </span>
                        <Select
                            className="flex-2"
                            value={currentPage}
                            optionFilterProp="children"
                            onChange={onChangeSize}
                            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                            options={pageSizes}
                        />
                    </Container>
                    <Container className="drow fullw gap-1 align-center">
                        <span className="flex-1">Side margin: </span>
                        <InputNumber
                            className="flex-2" value={sideMargin} onChange={(e) => {
                                setSideMargin(e)
                            }} />
                    </Container>
                    <Container className="drow fullw gap-1 align-center">
                        <span className="flex-1">Top margin: </span>
                        <InputNumber
                            className="flex-2" value={topMargin} onChange={(e) => {
                                setTopMargin(e)
                            }} />
                    </Container>
                </Container>
                <Container className="drow gap-1 justify-center fullw">
                    <Button onClick={onClickCancel} >Cancel</Button>
                    <Button onClick={onClickPrint} type="primary">Save</Button>
                </Container>
            </Container>
        </Container>
    </Modal>
}

export default PrintModal